import * as React from 'react';

import { translate } from '~l10n/client';
import _ from 'underscore';

import { proCheck } from '~teacher/util/proCheck';
import BackArrowIcon from 'BackArrowIcon';
import CloseX from 'CloseX';
import Constants from 'Constants';
import EmptyFolderIcon from 'EmptyFolderIcon';
import FeedbackIcon from 'FeedbackIcon';
import FolderIcon from 'FolderIcon';
import HelpTooltip from 'HelpTooltip';
import Input from 'Input';
import ListFolder from 'ListFolder';
import Loader from 'Loader';
import NoResultsIcon from 'NoResultsIcon';
import platform from 'Platform';
import RadioButton from 'RadioButton';
import RightChevron from 'RightChevron';
import SearchIcon from 'SearchIcon';
import Select from 'Select';
import SortDownIcon from 'SortDownIcon';
import SortUpIcon from 'SortUpIcon';
import StudentNavIcon from 'StudentNavIcon';
import TeacherPacedIcon from 'TeacherPacedIcon';
import Toggle from 'Toggle';
import Tooltip from 'Tooltip';
import utils from 'Utils';

const MAIN_HEADER = 49;
const STEP_HEADER = 60;
const FILTER_BAR = 68;
const MAIN_FOOTER = 56;

let c = null;
let m = null;

export default class LaunchQuizView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { searchFocused: false };
  }

  getSpaceRaceIcon(icon) {
    return (
      <img
        key={icon}
        className="start-quiz-space-race-icon"
        src={`${window.APP_CONFIG.STATIC_URL}${window.APP_CONFIG.VERSION}/img/space-race/${icon}-small.png`}
      />
    );
  }

  createAdditionalSettings() {
    let namesTooltip = null;
    const hasPaidPlan = proCheck.hasPaidPlan();
    const canAddRoster = proCheck.canAddRoster();
    const canOneAttempt = proCheck.canLimitOneAttempt();

    if (m.showNamesTooltip) {
      namesTooltip = {
        location: 'above',
        title: translate('Required'),
        text: translate('Student names are required in rooms with rosters.'),
      };
    }

    let feedbackTooltip = null;

    if (m.showFeedbackTooltip) {
      feedbackTooltip = {
        location: 'above',
        title: translate('Disabled'),
        text: translate(
          'Feedback is disabled because students can change answers before submitting.'
        ),
      };
    }

    let questionsTooltip = null;

    if (m.showQuestionsTooltip) {
      questionsTooltip = {
        location: 'above',
        title: translate('Disabled'),
        text: translate(
          'Questions are delivered in the same order to all students.'
        ),
      };
    }

    let methodTooltip = null;

    if (m.showMethodTooltip) {
      methodTooltip = {
        className: 'delivery-method-tooltip',
        location: 'above',
        text: translate('Please choose a delivery method first.'),
      };
      namesTooltip = methodTooltip;
    }

    let oneAttemptTooltip = null;

    if (m.showOneAttemptTooltip) {
      let title = translate('PRO Feature');
      let text = translate(
        'This setting is only available in rooms with rosters.'
      );

      if (canAddRoster && !this.props.hasRoster) {
        title = translate('Roster Required');
      }

      oneAttemptTooltip = {
        location: 'above',
        title: title,
        text: text,
      };
    }

    let additionalSettings = '';

    if (platform.isPhone()) {
      additionalSettings = (
        <span className="space-race-additional-settings-header">
          {translate('Additional Settings')}
        </span>
      );
    }

    return (
      <div
        key="additional-settings-1"
        className={
          'start-quiz-settings-container' +
          (platform.isPhone() ? '' : ' large-view')
        }
      >
        {additionalSettings}
        <Toggle
          checked={m.additionalSettings.requireNames || this.props.hasRoster}
          disabled={this.props.hasRoster || !m.deliveryMethod}
          id="start-quiz-require-names"
          label={translate('Require Names')}
          onChange={c.requireNamesChanged}
          onClick={(e) => {
            c.requireNamesClicked();
          }}
          tooltip={namesTooltip}
        />
        <Toggle
          checked={m.additionalSettings.shuffleQuestions}
          disabled={
            m.deliveryMethod === 'teacherPaced' ||
            (m.isQuiz && m.deliveryMethod === '')
          }
          id="start-quiz-shuffle-questions"
          label={translate('Shuffle Questions')}
          onChange={c.shuffleQuestionsChanged}
          onClick={(e) => {
            c.shuffleQuestionsClicked();
          }}
          tooltip={questionsTooltip}
        />
        <Toggle
          checked={m.additionalSettings.shuffleAnswers}
          disabled={m.isQuiz && m.deliveryMethod === ''}
          id="start-quiz-shuffle-answers"
          label={translate('Shuffle Answers')}
          onChange={c.shuffleAnswersChanged}
          onClick={c.shuffleAnswersClicked}
        />
        <Toggle
          checked={m.additionalSettings.showFeedback}
          disabled={
            m.deliveryMethod === 'navigation' ||
            (m.isQuiz && m.deliveryMethod === '')
          }
          id="start-quiz-show-feedback"
          label={translate('Show Question Feedback')}
          onChange={c.showFeedbackChanged}
          onClick={(e) => {
            c.showFeedbackClicked();
          }}
          tooltip={feedbackTooltip}
        />
        <Toggle
          checked={m.additionalSettings.showScore}
          disabled={m.isQuiz && m.deliveryMethod === ''}
          id="start-quiz-show-score"
          label={translate('Show Final Score')}
          onChange={c.showScoreChanged}
          onClick={c.showScoreClicked}
        />
        <Toggle
          checked={m.additionalSettings.oneAttempt}
          disabled={
            !this.props.hasRoster || (m.deliveryMethod === '' && m.isQuiz)
          }
          id="start-quiz-one-attempt"
          label={translate('One Attempt')}
          onChange={c.oneAttemptChanged}
          onClick={(e) => {
            c.oneAttemptClicked();
          }}
          tooltip={oneAttemptTooltip}
        >
          <HelpTooltip
            above={true}
            showProIcon={!hasPaidPlan}
            className="start-quiz-help-tooltip"
            title={
              canOneAttempt
                ? translate('One Attempt')
                : translate('PRO Feature')
            }
            text={translate(
              'Students can only take the quiz once. If they leave and rejoin the room, they will continue the quiz where they left off.'
            )}
          />
        </Toggle>
      </div>
    );
  }

  createDeliveryMethod(method) {
    let methodText = translate('Instant Feedback');
    if (method === 'navigation') {
      methodText = translate('Open Navigation');
    } else if (method === 'teacherPaced') {
      methodText = translate('Teacher Paced');
    }

    let Icon = FeedbackIcon;

    let svgClass = 'feedback-svg';

    let pathClass = 'feedback-path';

    if (method === 'navigation') {
      Icon = StudentNavIcon;
      svgClass = 'navigation-svg';
      pathClass = 'navigation-path';
    } else if (method === 'teacherPaced') {
      Icon = TeacherPacedIcon;
      svgClass = 'teacher-paced-svg';
      pathClass = 'teacher-paced-path';
    }

    let tooltipTitle = translate('Instant Feedback');
    let tooltipText = translate(
      'Students answer questions in order and cannot change answers. Instant feedback is provided after each question. You monitor progress in a table of live results.'
    );

    if (method === 'navigation') {
      tooltipTitle = translate('Open Navigation');
      tooltipText = translate(
        'Students may answer questions in any order and change answers before finishing. You monitor progress in a table of live results.'
      );
    } else if (method === 'teacherPaced') {
      tooltipTitle = translate('Teacher Paced');
      tooltipText = translate(
        'You control the flow of questions and monitor responses as they happen. You may skip and revisit questions.'
      );
    }

    let selected = m.deliveryMethod === method;

    return (
      <div className="delivery-method-container">
        <button
          className={`delivery-method-button ${
            selected ? ' delivery-method-button-selected' : ''
          }`}
          type="button"
          onClick={() => {
            if (method === 'feedback') {
              c.feedbackClicked();
            } else if (method === 'navigation') {
              c.navigationClicked();
            } else {
              c.teacherPacedClicked();
            }
          }}
        >
          <div className="delivery-method-button-content">
            <div
              className={`delivery-method-circle ${
                selected ? ' delivery-method-circle-selected' : ''
              }`}
            >
              <Icon
                svgClass={svgClass}
                pathClass={`${pathClass} ${
                  selected ? ' delivery-method-icon-selected' : ''
                }`}
              />
            </div>
            <span
              className={`delivery-method-text ${
                selected ? ' delivery-method-text-selected' : ''
              }`}
            >
              {methodText}
            </span>
          </div>
        </button>
        <HelpTooltip
          className="start-quiz-help-tooltip"
          above
          title={tooltipTitle}
          text={tooltipText}
        />
      </div>
    );
  }

  render() {
    c = this.props.controller;
    m = this.props.model;
    const canMakeFolders = proCheck.canMakeFolders();
    const canTimeSpaceRace = proCheck.canTimeSpaceRace();

    let step = m.step;

    let modalContentChildren = [];

    if (m.waiting) {
      modalContentChildren.push(
        <Loader
          key="modalContentChildren-loader-1"
          className="start-quiz-loader"
          text={m.waitingText}
        />
      );
    } else {
      let step1Children = [];

      let step2Children = [];

      let step1HeaderChildren = [
        <div
          key="step1HeaderChildren-div"
          className={
            'step-circle ' +
            (step === 1 ? 'active-step-circle' : 'inactive-step-circle')
          }
        >
          <span className="step-circle-text">1</span>
        </div>,
        <span
          key="step1HeaderChildren-span-1"
          className={
            'step-title-text ' +
            (step === 1 ? 'active-step-title-text' : 'inactive-step-title-text')
          }
        >
          {platform.isPhone() ? translate('Quiz') : translate('Choose Quiz')}
        </span>,
      ];

      if (step === 1) {
        step1HeaderChildren.push(
          <span
            key="step1HeaderChildren-span-2"
            className="step-x-of-x-text"
            dangerouslySetInnerHTML={{
              __html: translate('Step {0} <i>of</i> 2').format('1'),
            }}
          />
        );
      } else {
        step1HeaderChildren.push(
          <div
            key="step1HeaderChildren-div-2"
            className="selected-quiz-change-container"
          >
            <span className="selected-quiz-name-text">
              {utils.ellipsify(
                m.selectedQuiz.name,
                platform.isPhone() ? 15 : 50
              )}
            </span>
            <span
              className="selected-quiz-change-text link"
              onClick={c.previousClicked}
            >
              {translate('Change')}
            </span>
          </div>
        );
      }

      step1Children.push(
        <div key="step1HeaderChildren-div-1" className="step-header">
          {step1HeaderChildren}
        </div>
      );

      let step2HeaderChildren = [
        <div
          key="step2HeaderChildren-div-1"
          className={
            'step-circle ' +
            (step === 2 ? 'active-step-circle' : 'inactive-step-circle')
          }
        >
          <span className="step-circle-text">2</span>
        </div>,
        <span
          key="step2HeaderChildren-span-1"
          className={
            'step-title-text ' +
            (step === 2 ? 'active-step-title-text' : 'inactive-step-title-text')
          }
        >
          {m.step2Title}
        </span>,
        <span
          key="step2HeaderChildren-span-2"
          className={
            'step-x-of-x-text' +
            (step === 1 ? ' inactive-step-x-of-x-text' : '')
          }
          dangerouslySetInnerHTML={{
            __html: translate('Step {0} <i>of</i> 2').format('2'),
          }}
        />,
      ];

      step2Children.push(
        <div
          key="step2HeaderChildren-div-1"
          className="step-header step-header-2"
        >
          {step2HeaderChildren}
        </div>
      );

      if (step === 1) {
        let filterChildren = [
          <SearchIcon
            key="filterChildren-search-icon"
            className="start-quiz-search-icon"
          />,
          <Input
            key="filterChildren-search-input"
            autoCapitalize="off"
            id="start-quiz-search-input"
            maxLength={255}
            onFocus={() => {
              if (window.innerWidth < 768 && !m.isIntegration) {
                let footer = document.getElementById('start-quiz-footer');
                if (footer) {
                  footer.style.position = 'absolute'; // Prevent the footer from covering the search input.
                }
                this.setState({ searchFocused: true });
              }
            }}
            onBlur={() => {
              if (window.innerWidth < 768 && !m.isIntegration) {
                setTimeout(() => {
                  this.setState({ searchFocused: false });
                  let footer = document.getElementById('start-quiz-footer');
                  if (footer) {
                    footer.style.position = 'fixed';
                  }
                }, 375);
              }
            }}
            onChange={(event) => c.searchTextChanged(event.target.value)}
            onKeyPress={(event) => {
              if (event.key === 'Enter' && platform.isMobile()) {
                event.target.blur();
              }
            }}
            placeholder={translate('Search Quizzes')}
            type="text"
            value={m.searchText || ''}
          />,
        ];

        if (m.searchText.length > 0) {
          filterChildren.push(
            <div
              key="filterChildren-div-2"
              className="clear-search"
              onClick={c.clearSearchClicked}
            >
              <CloseX
                className="clear-search-x"
                color={Constants.CLEAR_INPUT_X}
              />
            </div>
          );
        }

        step1Children.push(
          <div key="step1Children-div-2" className="start-quiz-filter-bar">
            {filterChildren}
          </div>
        );

        let rootFolder = m.currentFolder.id === Constants.ROOT_FOLDER;

        let folderConextChildren = [];

        if (!rootFolder && m.searchText.length === 0) {
          folderConextChildren.push(
            <button
              key="folderConextChildren-button-1"
              className="launch-quiz-back-button"
              onClick={c.backClicked}
            >
              {m.isIntegration ? (
                <svg
                  className="launch-quiz-back-button-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="#06b7d8"
                    strokeWidth="2"
                  >
                    <path d="M10 1L2 9l8 8" />
                    <path strokeLinecap="square" d="M3.758 9H17" />
                  </g>
                </svg>
              ) : (
                <BackArrowIcon className="launch-quiz-back-button-icon" />
              )}
            </button>
          );
        }

        let labelClass = 'launch-quiz-current-folder-label';

        if (rootFolder || m.searchText.length > 0) {
          labelClass += ' launch-quiz-current-folder-label-root';
        }

        folderConextChildren.push(
          <span key="folderConextChildren-span-1" className={labelClass}>
            {m.searchText.length > 0
              ? translate('Search Results')
              : m.currentFolder.name}
          </span>
        );

        let folderConextRowClass = 'launch-quiz-folder-context-row';

        if (rootFolder || m.searchText.length > 0) {
          folderConextRowClass = 'launch-quiz-folder-context-row-root';
        }

        step1Children.push(
          <div key="step1Children-key-div-3" className={folderConextRowClass}>
            {folderConextChildren}
          </div>
        );

        let NameSortIcon =
          m.sortDirection === 'asc' ? SortUpIcon : SortDownIcon;

        if (m.sortColumn !== 'name') {
          NameSortIcon = SortUpIcon;
        }

        let DateSortIcon =
          m.sortDirection === 'asc' ? SortUpIcon : SortDownIcon;

        if (m.sortColumn !== 'date') {
          DateSortIcon = SortDownIcon;
        }

        let tableChildren = [
          <tr key={`tablechildren-quiz-tr-1`}>
            <th className="start-quiz-radio-column" />
            <th className="start-quiz-name-column">
              <span
                className={
                  'start-quiz-sort-header' +
                  (m.sortColumn === 'name'
                    ? ' start-quiz-active-sort-header'
                    : '')
                }
                title={translate('Sort by name')}
                onClick={() => c.columnClicked('name')}
              >
                <span className="start-quiz-column-header-text">
                  {translate('Name', true)}
                </span>
                <NameSortIcon
                  className={
                    'start-quiz-sort-icon' +
                    (m.sortColumn === 'name'
                      ? ' start-quiz-active-sort-icon'
                      : '')
                  }
                />
              </span>
            </th>
            <th className="start-quiz-date-column">
              <span
                className={
                  'start-quiz-sort-header' +
                  (m.sortColumn === 'date'
                    ? ' start-quiz-active-sort-header'
                    : '')
                }
                title={translate('Sort by date')}
                onClick={() => c.columnClicked('date')}
              >
                <span className="start-quiz-column-header-text">
                  {translate('Date', true)}
                </span>
                <DateSortIcon
                  className={
                    'start-quiz-sort-icon' +
                    (m.sortColumn === 'date'
                      ? ' start-quiz-active-sort-icon'
                      : '')
                  }
                />
              </span>
            </th>
          </tr>,
        ];

        let foldersToDisplay = this.props.searchResultFolders;

        if (m.searchText.length === 0) {
          foldersToDisplay = [];

          if (canMakeFolders) {
            for (let folder of m.currentFolder.children) {
              if (!folder.deleted) {
                foldersToDisplay.push(folder);
              }
            }

            if (m.sortColumn === 'name') {
              foldersToDisplay = _.sortBy(foldersToDisplay, (folder) => {
                return folder.name.toLowerCase();
              });
            } else {
              foldersToDisplay = _.sortBy(foldersToDisplay, 'date');
            }

            if (m.sortDirection === 'desc') {
              foldersToDisplay.reverse(); // Underscore sorts ascending by default, so reverse if needed.
            }
          }
        }

        for (let folder of foldersToDisplay) {
          tableChildren.push(
            m.isIntegration ? (
              <tr
                key={`tablechildren-quiz-${folder.id}-tr-2`}
                className="launch-quiz-folder-row"
                onClick={() => c.folderClicked(folder)}
              >
                <td>
                  <div className="list-folder-icon-container">
                    <FolderIcon className="list-folder-icon" />
                  </div>
                </td>
                <td>
                  <span className="list-folder-name">{folder.name}</span>
                </td>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      paddingRight: '1rem',
                    }}
                  >
                    <RightChevron
                      className="list-folder-go-button-icon"
                      color="#b9bbbd"
                    />
                  </div>
                </td>
              </tr>
            ) : (
              <tr
                key={`tablechildren-quiz-${folder.id}-tr-3`}
                className="launch-quiz-folder-row"
              >
                <td colSpan={3}>
                  <ListFolder
                    className="launch-quiz-list-folder"
                    hideButton={false}
                    id={folder.id}
                    name={folder.name}
                    onClick={() => c.folderClicked(folder)}
                  />
                </td>
              </tr>
            )
          );
        }

        if (this.props.visibleQuizzes.length > 0) {
          for (let quiz of this.props.visibleQuizzes) {
            let selected = m.selectedQuiz && m.selectedQuiz.id === quiz.id;

            let cellChildren = [
              <td
                key={`cellChildren-quiz-1${quiz.id}-td-1`}
                className="start-quiz-radio-column"
              >
                <div
                  className={
                    'start-quiz-radio-outer' +
                    (selected ? ' start-quiz-radio-outer-selected' : '')
                  }
                >
                  <div
                    className="start-quiz-radio-inner"
                    style={{ visibility: selected ? 'visible' : 'hidden' }}
                  />
                </div>
              </td>,
            ];

            let nameChildren = [
              <span
                key={`nameChildren-quiz-1${quiz.id}-span-1`}
                className="start-quiz-name-text"
              >
                {quiz.name}
              </span>,
            ];

            if (quiz.standard && quiz.standard.length > 0) {
              nameChildren.push(
                <div
                  key={`nameChildren-quiz-1${quiz.id}-span-2`}
                  className="start-quiz-standard-text"
                >
                  {quiz.standard}
                </div>
              );
            }

            cellChildren.push(
              <td
                key={`cellChildren-quiz-1${quiz.id}-td-2`}
                className="start-quiz-name-column"
              >
                {nameChildren}
              </td>,
              <td
                key={`cellChildren-quiz-1${quiz.id}-td-3`}
                className="start-quiz-date-column"
              >
                {'{0}/{1}/{2}'.format(
                  quiz.date.getMonth() + 1,
                  quiz.date.getDate(),
                  quiz.date.getFullYear() - 2000
                )}
              </td>
            );

            tableChildren.push(
              <tr
                key={`tablechildren-quiz-${quiz.id}-tr-1`}
                className={
                  'start-quiz-row' +
                  (selected ? ' selected-start-quiz-row' : '')
                }
                onClick={() => c.quizClicked(quiz.id, quiz.soc, quiz.name)}
              >
                {cellChildren}
              </tr>
            );
          }
        }

        let noChildFolders = m.currentFolder.children.length === 0;

        let noSearchResultFolders =
          m.searchText.length > 0 &&
          this.props.searchResultFolders.length === 0;

        let noQuizzes = this.props.visibleQuizzes.length === 0;

        let allChildFoldersDeleted = true;

        for (let child of m.currentFolder.children) {
          if (!child.deleted) {
            allChildFoldersDeleted = false;
            break;
          }
        }

        if (
          (noChildFolders || noSearchResultFolders || allChildFoldersDeleted) &&
          noQuizzes
        ) {
          let emptyFolder =
            (noChildFolders || allChildFoldersDeleted) &&
            m.searchText.length === 0;

          let NoQuizzesIcon = emptyFolder ? EmptyFolderIcon : NoResultsIcon;

          let noQuizzesChildren = [
            <NoQuizzesIcon
              key="noQuizzesChildren-noquizzesicon"
              className="no-quizzes-found-icon"
              useNew={m.isIntegration}
            />,
            <span
              key="noQuizzesChildren-span-1"
              className={
                'no-quizzes-found-large-text' +
                (emptyFolder ? ' empty-folder-large-text' : '')
              }
            >
              {emptyFolder
                ? translate('This folder is empty')
                : translate('Nothing found matching “{0}”.').format(
                    m.searchText
                  )}
            </span>,
          ];

          if (m.searchText.length > 0) {
            noQuizzesChildren.push(
              <span className="no-quizzes-found-small-text">
                {translate('Delete search terms to start over.')}
              </span>
            );
          }

          let noQuizzesFoundContainerHeight = 160;

          if (window.innerWidth < 768 && !this.state.searchFocused) {
            const NO_QUIZZES_MARGIN = 40;
            noQuizzesFoundContainerHeight =
              window.innerHeight -
              (m.isIntegration ? 72 : MAIN_HEADER) -
              STEP_HEADER -
              (m.isIntegration ? 0 : FILTER_BAR) -
              (m.isIntegration ? 96 : NO_QUIZZES_MARGIN) -
              STEP_HEADER -
              (m.isIntegration ? 72 : MAIN_FOOTER); // Make the modal fit in the view port.
          }

          /**
           * Set the height for the integration view by force here
           * since the equations above don't seem to have an effect.
           */
          if (m.isIntegration) {
            noQuizzesFoundContainerHeight = window.innerWidth < 480 ? 200 : 260;
          }

          step1Children.push(
            <div
              key="step1Children-div-4"
              className={
                'no-quizzes-found-container' +
                (emptyFolder ? ' empty-folder-container' : '')
              }
              style={{ height: noQuizzesFoundContainerHeight + 'px' }}
            >
              {noQuizzesChildren}
            </div>
          );
        } else {
          let quizListHeight = 240;

          if (window.innerWidth < 768 && !this.state.searchFocused) {
            quizListHeight =
              window.innerHeight -
              (m.isIntegration ? 72 : MAIN_HEADER) -
              STEP_HEADER -
              (m.isIntegration ? 0 : FILTER_BAR) -
              STEP_HEADER -
              (m.isIntegration ? 72 : MAIN_FOOTER); // Make the modal fit in the view port.
          }

          /**
           * Set the height for the integration view by force here
           * since the equations above don't seem to have an effect.
           */
          if (m.isIntegration) {
            quizListHeight = window.innerWidth < 480 ? 200 : 260;
          }

          step1Children.push(
            <div
              key="step1Children-div-5"
              className="start-quiz-table-container"
              style={{ height: quizListHeight + 'px' }}
            >
              <table className="start-quiz-table">
                <tbody>{tableChildren}</tbody>
              </table>
            </div>
          );
        }
      } else {
        if (m.isQuiz) {
          step2Children.push(
            <div key="step2Children-div-2" className="step-column-container">
              <div className="start-quiz-delivery-container">
                {this.createDeliveryMethod('feedback')}
                {this.createDeliveryMethod('navigation')}
                {this.createDeliveryMethod('teacherPaced')}
              </div>
              {this.createAdditionalSettings()}
            </div>
          );
        } else {
          let teamCountOptions = [];
          for (let i = 2; i <= 20; i++) {
            teamCountOptions.push({
              title: i,
              value: i,
              selected: i === m.teamCount,
            });
          }

          let iconOptions = [
            {
              leftIcon: this.getSpaceRaceIcon('rocket'),
              iconClass: 'space-race-icon',
              title: translate('Rocket'),
              value: 'rocket',
              selected: m.icon === 'rocket',
            },
            {
              leftIcon: this.getSpaceRaceIcon('bear'),
              iconClass: 'space-race-icon',
              title: translate('Bear'),
              value: 'bear',
              selected: m.icon === 'bear',
            },
            {
              leftIcon: this.getSpaceRaceIcon('bee'),
              iconClass: 'space-race-icon',
              title: translate('Bee'),
              value: 'bee',
              selected: m.icon === 'bee',
            },
            {
              leftIcon: this.getSpaceRaceIcon('bicycle'),
              iconClass: 'space-race-icon',
              title: translate('Bicycle'),
              value: 'bicycle',
              selected: m.icon === 'bicycle',
            },
            {
              leftIcon: this.getSpaceRaceIcon('spaceship'),
              iconClass: 'space-race-icon',
              title: translate('Spaceship'),
              value: 'spaceship',
              selected: m.icon === 'spaceship',
            },
            {
              leftIcon: this.getSpaceRaceIcon('unicorn'),
              iconClass: 'space-race-icon',
              title: translate('Unicorn'),
              value: 'unicorn',
              selected: m.icon === 'unicorn',
            },
          ];

          let date = new Date();
          if (date.getMonth() === 10) {
            iconOptions.push({
              leftIcon: this.getSpaceRaceIcon('turkey'),
              iconClass: 'space-race-icon',
              title: translate('Seasonal'),
              value: 'turkey',
              selected: m.icon === 'turkey',
            });
          } else if (date.getMonth() === 11) {
            iconOptions.push({
              leftIcon: this.getSpaceRaceIcon('reindeer'),
              iconClass: 'space-race-icon',
              title: translate('Seasonal'),
              value: 'reindeer',
              selected: m.icon === 'reindeer',
            });
          } else if (date.getMonth() === 9) {
            iconOptions.push({
              leftIcon: this.getSpaceRaceIcon('pumpkin'),
              iconClass: 'space-race-icon',
              title: translate('Seasonal'),
              value: 'pumpkin',
              selected: m.icon === 'pumpkin',
            });
          }

          let countdownOptions = [
            {
              title: translate('None'),
              value: -1,
              selected: m.countdown === -1,
            },
          ];

          for (let i = 1; i <= 15; i++) {
            let minutes = i;
            if (i === 11) minutes = 15;
            if (i === 12) minutes = 20;
            if (i === 13) minutes = 25;
            if (i === 14) minutes = 30;
            if (i === 15) minutes = 45;

            let title = translate('{0} minutes').format(minutes);
            if (minutes === 1) {
              title = ' ' + translate('1 minute');
            } else if (minutes < 10) {
              title = ` ${title}`;
            }

            let seconds = minutes * 60;

            countdownOptions.push({
              title: title,
              value: seconds,
              selected: seconds === m.countdown,
            });
          }

          let countdownChildren = [
            <p key="countdownChildren-p-1" className="space-race-select-label">
              {translate('Countdown')}
            </p>,
            <Select
              key="countdownChildren-select-1"
              disabled={!canTimeSpaceRace}
              onClickDisabled={(e) => {
                if (!canTimeSpaceRace) {
                  c.disabledCountdownClicked();
                }
              }}
              onSelect={(name, value) => c.countdownChanged(value)}
            >
              {countdownOptions}
            </Select>,
          ];

          if (m.showCountdownTooltip) {
            countdownChildren.push(
              <Tooltip
                key="countdownChildren-ToolTip-1"
                location="above"
                title={translate('PRO Feature')}
                text={translate(
                  'This setting is available to Socrative PRO users.'
                )}
              />
            );
          }

          step2Children.push(
            <div
              key="step2Children-div-3"
              className="start-quiz-select-container"
            >
              <div className="space-race-select-container teams-container">
                <p className="space-race-select-label">{translate('Teams')}</p>
                <Select
                  error={m.teamCountError}
                  label={translate('Number of Teams')}
                  onSelect={(name, value) => c.teamCountChanged(value)}
                >
                  {teamCountOptions}
                </Select>
              </div>
              <div className="radio-buttons-container">
                <RadioButton
                  className="auto-assign-radio"
                  label={translate('Auto-assign')}
                  selected={m.teamAssignment === 'auto'}
                  onClick={() => c.teamAssignmentChanged('auto')}
                />
                <RadioButton
                  className="student-choice-radio"
                  label={translate('Student Choice')}
                  selected={m.teamAssignment === 'student'}
                  onClick={() => c.teamAssignmentChanged('student')}
                />
              </div>
              <div className="space-race-select-container">
                <p className="space-race-select-label">{translate('Icon')}</p>
                <Select onSelect={(name, value) => c.iconChanged(value)}>
                  {iconOptions}
                </Select>
              </div>
              <div className="space-race-select-container countdown-container">
                {countdownChildren}
              </div>
            </div>,
            this.createAdditionalSettings()
          );
        }
      }

      modalContentChildren.push(
        <div
          key="modalContentChildren-div-1"
          className={`step1 ${step === 1 ? 'is-visible' : ''}`}
        >
          {step1Children}
        </div>,
        <div
          key="modalContentChildren-div-2"
          className={`step2 ${step === 2 ? 'is-visible' : ''}`}
        >
          {step2Children}
        </div>
      );
    }

    let modalChildren = [
      <div key="modalChildren-div-1" className="modal-header">
        <span className="popup-title">{m.step1Title}</span>
        <div className="cancel-button" onClick={c.cancelClicked}>
          <CloseX className="cancel-button-x" color="#cccccc" />
        </div>
      </div>,
      <div
        key="modalChildren-div-2"
        id="start-quiz-modal-content"
        className="modal-content form"
      >
        {modalContentChildren}
      </div>,
    ];

    if (!m.waiting) {
      let footerChildren = [
        <button
          key="footerChildren-button-1"
          className="start-quiz-footer-button start-quiz-previous-button"
          disabled={step === 1}
          onClick={c.previousClicked}
        >
          {translate('Previous')}
        </button>,
      ];

      if (step === 1) {
        footerChildren.push(
          <button
            key="footerChildren-button-2"
            className="start-quiz-footer-button start-quiz-next-button"
            disabled={!m.selectedQuiz}
            onClick={c.nextClicked}
          >
            {translate('Next')}
          </button>
        );
      } else {
        let disabled = false;

        if (m.isQuiz) {
          disabled = !m.deliveryMethod;
        } else {
          disabled = m.teamCount === 0;
        }

        footerChildren.push(
          <button
            className="start-quiz-footer-button start-quiz-start-button"
            disabled={disabled}
            key="launch-quiz-start"
            onClick={c.startClicked}
          >
            {translate('Start')}
          </button>
        );
      }

      modalChildren.push(
        <div
          key="modalChildren-div-3"
          id="start-quiz-footer"
          className="start-quiz-footer form"
        >
          {footerChildren}
        </div>
      );
    }

    return (
      <div id="start-quiz-modal-background" className="modal open">
        <div
          id="start-quiz-modal-box"
          className={m.isIntegration ? 'integration-launch' : 'modal-dialog'}
        >
          {modalChildren}
        </div>
      </div>
    );
  }
}
